import { render, staticRenderFns } from "./Basvuru_Yeni_Giris.vue?vue&type=template&id=4da1f2a5&scoped=true&"
import script from "./Basvuru_Yeni_Giris.vue?vue&type=script&lang=js&"
export * from "./Basvuru_Yeni_Giris.vue?vue&type=script&lang=js&"
import style0 from "./Basvuru_Yeni_Giris.vue?vue&type=style&index=0&id=4da1f2a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1f2a5",
  null
  
)

export default component.exports